import React, { useState, useEffect } from 'react';

const PrayerTimesPage = () => {
  const [prayerTimes, setPrayerTimes] = useState([]);
  const [location, setLocation] = useState({ latitude: 0, longitude: 0 });
  const [loading, setLoading] = useState(true);

  // دالة لجلب أوقات الصلاة للشهر الحالي
  const fetchPrayerTimes = async () => {
    const apiKey = 'YOUR_ALADHAN_API_KEY'; // استبدل بمفتاح API الخاص بك من Aladhan
    const month = new Date().getMonth() + 1; // الشهر الحالي
    const year = new Date().getFullYear(); // السنة الحالية

    try {
      const response = await fetch(
        `http://api.aladhan.com/v1/calendar?latitude=${location.latitude}&longitude=${location.longitude}&month=${month}&year=${year}&method=2`
      );
      const data = await response.json();
      setPrayerTimes(data.data);
      setLoading(false);
    } catch (error) {
      console.error('خطأ في جلب أوقات الصلاة:', error);
    }
  };

  // الحصول على الموقع الجغرافي للمستخدم
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLocation({ latitude, longitude });
        },
        (error) => {
          console.error(error);
          alert('تعذر الحصول على موقعك');
        }
      );
    }
  }, []);

  // جلب أوقات الصلاة عندما يتوفر الموقع
  useEffect(() => {
    if (location.latitude && location.longitude) {
      fetchPrayerTimes();
    }
  }, [location]);

  return (
    <div className="container mx-auto p-6 bg-gradient-to-tr from-green-300 to-gray-300">
      <h1 className="text-4xl font-bold text-center mb-6 text-green-700">أوقات الصلاة لهذا الشهر</h1>

      {loading ? (
        <div className="text-center">جاري تحميل أوقات الصلاة...</div>
      ) : (
        <div>
          <h2 className="text-2xl font-semibold text-center mb-4">أوقات الصلاة لشهر {new Date().toLocaleString('default', { month: 'long' })} {new Date().getFullYear()}</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {prayerTimes.map((day, index) => (
              <div key={index} className="bg-white p-4 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
                <h3 className="font-semibold text-[#26B75D] text-lg">{`اليوم ${index + 1}`}</h3>
                <div className="text-sm">
                  <p><strong>الفجر:</strong> {day.timings.Fajr}</p>
                  <p><strong>الظهر:</strong> {day.timings.Dhuhr}</p>
                  <p><strong>العصر:</strong> {day.timings.Asr}</p>
                  <p><strong>المغرب:</strong> {day.timings.Maghrib}</p>
                  <p><strong>العشاء:</strong> {day.timings.Isha}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PrayerTimesPage;
